import React, { Component } from 'react'
import { withStyles, Drawer, Typography, Divider, TextField, Button, AppBar, Toolbar, IconButton, FormControl, InputLabel, Select, OutlinedInput, MenuItem } from '@material-ui/core';

const drawerWidth = 500;

const styles = theme => ({
    root: {
        width: drawerWidth,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '100%'
    },
    textStyle: {
        fontWeight: 400
    },
    paddingForm: {
        padding: '20px'
    }
})

class StaffAdd extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            qualification: '',
            designation: '',
            type: '',
            phn: '',
            id: ''
        }

        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);

    }

    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    componentDidMount() {
        if (this.props.edit) {
            this.setState({
                ...this.props.edit_data
            })
        } else {
            this.setState({
                name: '',
                qualification: '',
                designation: '',
                type: '',
                phn: '',
                id: ''
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            if (this.props.edit) {
                this.setState({
                    ...this.props.edit_data
                })
            } else {
                this.setState({
                    name: '',
                    qualification: '',
                    designation: '',
                    type: '',
                    phn: '',
                    id: ''
                })
            }
        }
    }


    onSubmit(e) {
        e.preventDefault();

        const data = this.state;

        if (this.props.edit) {
            this.props.esetData(data);

        } else {
            this.props.setData(data);
            this.setState({
                name: '',
                qualification: '',
                designation: '',
                type: '',
                phn: '',
                id: ''

            })
        }

    }

    onDeleteClick(id) {
        this.props.onDeleteClick(id);
    }

    render() {
        let { classes } = this.props;
        return (
            <div>
                <Drawer
                    className={classes.root}
                    anchor="right"
                    open={this.props.show}
                    onClose={this.props.handleClose}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                >

                    <AppBar position="static" color={this.props.edit ? "secondary" : "primary"} >
                        <Toolbar>
                            <Typography variant="h6" color="inherit" >
                                {this.props.edit ? "Edit DATA" : "Add New"}
                            </Typography>
                        </Toolbar>
                    </AppBar>

                    <div className={classes.paddingForm}>

                        <form onSubmit={this.onSubmit}>
                            <FormControl variant="outlined" className={classes.formControl} fullWidth>
                                <InputLabel >
                                    Select Mode
                    </InputLabel>
                                <Select
                                    value={this.state.type}
                                    onChange={this.onChange}
                                    input={
                                        <OutlinedInput labelWidth={200} name="type" />
                                    }
                                    required={true}
                                    name="type"

                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>

                                    <MenuItem value="REGULAR">REGULAR</MenuItem>
                                    <MenuItem value="CONTRACTUAL">CONTRACTUAL</MenuItem>
                                    <MenuItem value="RETIRED_STAFF">RETIRED_STAFF</MenuItem>
                                </Select>
                            </FormControl>
                            <br></br>
                            <TextField
                                variant="outlined"
                                label="Name"
                                className={classes.textField}
                                type="text"
                                name="name"
                                autoComplete="current-password"
                                margin="normal"
                                required
                                InputLabelProps={{
                                    classes: {
                                        root: classes.textStyle
                                    }
                                }}
                                value={this.state.name}
                                onChange={this.onChange}
                            />



                            <TextField
                                variant="outlined"
                                label="Qualification"
                                className={classes.textField}
                                type="text"
                                name="qualification"
                                autoComplete="current-password"
                                margin="normal"
                                
                                InputLabelProps={{
                                    classes: {
                                        root: classes.textStyle
                                    }
                                }}
                                value={this.state.qualification}
                                onChange={this.onChange}
                            />


                            <FormControl variant="outlined" className={classes.formControl} fullWidth>
                                <InputLabel >
                                    Select Type
                    </InputLabel>
                                <Select
                                    value={this.state.designation}
                                    onChange={this.onChange}
                                    input={
                                        <OutlinedInput labelWidth={200} name="designation" />
                                    }
                                    
                                    name="designation"

                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>

                                    <MenuItem value="SCIENTIFIC ASSISTANT">SCIENTIFIC ASSISTANT</MenuItem>
                                    <MenuItem value="PROGRAMMER CUM SYSTEM ANALYST">PROGRAMMER CUM SYSTEM ANALYST</MenuItem>
                                    <MenuItem value="TECHNICAL ASSISTANT">TECHNICAL ASSISTANT</MenuItem>
                                    <MenuItem value="GUEST INSTRUCTOR">GUEST INSTRUCTOR</MenuItem>

                                </Select>
                            </FormControl>

                            <br />
                            <TextField
                                variant="outlined"
                                label="Phone"
                                className={classes.textField}
                                type="number"
                                name="phn"
                                autoComplete="current-password"
                                margin="normal"
                                
                                InputLabelProps={{
                                    classes: {
                                        root: classes.textStyle
                                    }
                                }}
                                value={this.state.phn}
                                onChange={this.onChange}
                            />
                            <br />
                            <div>

                                <Button
                                    type="submit"
                                    variant="contained"
                                    color={this.props.edit ? "secondary" : "primary"}
                                    className={classes.button}>
                                    {this.props.edit ? "Update" : "Submit"}
                                </Button>

                                {this.props.edit ?
                                    <span>&nbsp;
                                    <Button
                                            type="button"
                                            variant="contained"
                                            color="secondary"
                                            className={classes.button}
                                            onClick={this.onDeleteClick.bind(this, this.props.edit_data.id)}
                                        >
                                            Delete
                                    </Button>
                                    </span>

                                    : null}
                            </div>
                        </form>

                    </div>



                </Drawer>
            </div>
        )
    }
}

export default withStyles(styles)(StaffAdd)


// WEBPACK FOOTER //
// ./src/Components/Master/Staff/StaffAdd.js